// Unauthorized access page component

import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { getAppConfig } from '../../types/env'
import styles from './UnauthorizedPage.module.css'

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate()
  const { user, logout } = useAuth()
  const config = getAppConfig()

  const handleGoHome = () => {
    navigate('/')
  }

  const handleLogout = async () => {
    await logout()
    navigate('/login')
  }

  const handleGoBack = () => {
    navigate(-1)
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.iconContainer}>
          <div className={styles.icon}>🚫</div>
        </div>

        <h1 className={styles.title}>Access Denied</h1>
        
        <p className={styles.message}>
          Sorry, you don't have permission to access this page.
        </p>

        {user && (
          <div className={styles.userInfo}>
            <p className={styles.userDetails}>
              Signed in as: <strong>{user.name}</strong> ({user.email})
            </p>
            <p className={styles.roleInfo}>
              Your role: <span className={styles.role}>{user.role}</span>
            </p>
          </div>
        )}

        <div className={styles.actions}>
          <button 
            onClick={handleGoBack}
            className={styles.secondaryButton}
          >
            Go Back
          </button>
          
          <button 
            onClick={handleGoHome}
            className={styles.primaryButton}
          >
            Go to Dashboard
          </button>
          
          <button 
            onClick={handleLogout}
            className={styles.logoutButton}
          >
            Sign Out
          </button>
        </div>

        <div className={styles.helpText}>
          <p>
            If you believe this is an error, please contact your administrator 
            or check with your event coordinator about your access permissions.
          </p>
        </div>

        <div className={styles.footer}>
          <span className={styles.appName}>{config.app.name}</span>
          <span className={styles.version}>v{config.app.version}</span>
        </div>
      </div>
    </div>
  )
}